<div class="exception-container">
  <router-outlet></router-outlet>
</div>
